// extracted by mini-css-extract-plugin
module.exports = {"leftLogo":"HeaderLogo_leftLogo__qxUmA","rightLogo":"HeaderLogo_rightLogo__1Gm27","leftLogoText":"HeaderLogo_leftLogoText__2FJfy","rightLogoText":"HeaderLogo_rightLogoText__39UA2"};